/*
 * generator drip-form自定义主题
 * @Author: jiangxiaowei
 * @Date: 2022-05-06 10:45:33
 * @Last Modified by: jiangxiaowei
 * @Last Modified time: 2022-05-19 14:33:49
 */
import { inputCopy } from './InputCopyField'
import { uiTypeChange } from './UiTypeChangeField'

export default {
  theme: 'generatorTheme',
  inputCopy,
  uiTypeChange,
}
